import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { classTypeFilter, classTypeFilterSelection, defaultClassTypeSelection, orgsFilterSelection, schoolYearFilterSelection, } from 'app/dataProviders/filter-items'
import { subscibeTo } from 'app/common/data-box-store'
import { useCallback, useEffect, useState } from 'react'


type Props = {
  id: string
  pending: boolean
}

export const ClassTypeFilter = ({ id, pending }: Props) => {

  const handleOrgsFilter = useCallback((data: string[]) => {
    classTypeFilterSelection.resetToDefault()
  }, [])

  const handleSchoolYearFilter = useCallback((data: string[]) => {
    classTypeFilterSelection.resetToDefault()
  }, [])



  useEffect(() => {
    const orgsUnsubsсribe = subscibeTo<string[]>(orgsFilterSelection.id, handleOrgsFilter)
    const schoolYearUnsubsсribe = subscibeTo<string[]>(schoolYearFilterSelection.id, handleSchoolYearFilter)

    return (() => {
      orgsUnsubsсribe()
      schoolYearUnsubsсribe()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип класса"
      header="Выбор типа класса"
      dataBoxData={classTypeFilter}
      dataBoxSelection={classTypeFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      defaultSelection={defaultClassTypeSelection}
      disabled={pending}
    />
  )
}
